import React from 'react';
import { makeStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SvgIcon from '@material-ui/core/SvgIcon';

import LeftIcon from 'moods-stylesheets/src/icons/icon__ui--chevron-left-xbold.svg';
import RightIcon from 'moods-stylesheets/src/icons/icon__ui--chevron-right-xbold.svg';
import ButtonBase from '@material-ui/core/ButtonBase';

import moods from '../moods-theme';

const theme = createTheme(moods);

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
}));

const useScrollButtonStyles = makeStyles(() => ({
  root: {
    width: 64,
    height: 45,
    position: 'absolute',
    zIndex: 1,
  },
  left: {
    left: 0,
    top: 0,
    backgroundImage: `linear-gradient(to right, ${moods.palette.grey[100]} 30%,  rgba(255, 255, 255, 0))`,
    justifyContent: 'flex-start',
  },
  right: {
    right: 0,
    top: 0,
    backgroundImage: `linear-gradient(to left,  ${moods.palette.grey[100]} 30%, rgba(255, 255, 255, 0))`,
    justifyContent: 'flex-end',
  },
  svg: {
    width: 22,
    height: 22,
  },
}));

const TabScrollButton = function TabScrollButton(props) {
  const { className, direction, visible, ...other } = props;
  const classes = useScrollButtonStyles();
  const Icon = direction === 'left' ? LeftIcon : RightIcon;
  const directionClassname = direction === 'left' ? classes.left : classes.right;
  const styles = `${className} ${classes.root} ${directionClassname}`;

  if (!visible) {
    return null;
  }

  return (
    <ButtonBase component="div" className={styles} tabIndex={null} {...other}>
      <SvgIcon component={Icon} viewBox="0 0 48 48" className={classes.svg} />
    </ButtonBase>
  );
};

export function TabNavigation({ tabs = [], delegate }) {
  const classes = useStyles();
  const selectedIndex = tabs.findIndex(({ selected }) => selected);
  const defaultSelectedTab = selectedIndex < 0 ? 0 : selectedIndex;
  const [selectedTab, setSelectedTab] = React.useState(defaultSelectedTab);
  const tabsActions = React.useRef();

  React.useEffect(() => setSelectedTab(defaultSelectedTab), [defaultSelectedTab]);

  React.useEffect(() => {
    let timer;
    if (tabsActions.current) {
      timer = setTimeout(() => {
        tabsActions.current.updateIndicator();
      }, 500); // Wierd hack to update position after layout changes, 500ms is the magic number
    }
    return () => timer && clearTimeout(timer);
  });

  const handleChange = (event, newIndex) => {
    setSelectedTab(newIndex);
  };

  const mappedTabs = tabs.map(({ label, delegateProps = {} }, tabIndex) => {
    const delegateComponentProps = delegate ? { component: delegate, ...delegateProps } : {};
    return <Tab label={label} {...delegateComponentProps} key={`tab-${tabIndex}`} />;
  });

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <Tabs
          action={tabsActions}
          value={selectedTab}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
          ScrollButtonComponent={TabScrollButton}
        >
          {mappedTabs}
        </Tabs>
      </div>
    </ThemeProvider>
  );
}
